function getLocalTime(i) {
    if (typeof i !== 'number') return;
    var d = new Date();
    //得到1970年一月一日到现在的秒数 
    var len = d.getTime();
    //本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）
    var offset = d.getTimezoneOffset() * 60000;
    //得到现在的格林尼治时间
    var utcTime = len + offset;
    return new Date(utcTime + 3600000 * i);
}
function get_compare_time(beginTime,endTime) {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    // 获取倒计时开始时间的时间戳（需要传入世界协调时）
    const countStart = Date.parse(beginTime)
    // 获取倒计时结束时间的时间戳（需要传入世界协调时）
    const countEnd = Date.parse(endTime)
    // 获取当前时间的时间戳 （世界协调时）
    const now = getLocalTime(0).getTime()
    //现在距离活动开始或结束时间的时间
    let startDistance= countStart-now;
    let endDistance= countEnd-now;
    /*
        @ nowType:
        0: "活动开始前"
        1: "活动进行中"
        2: "活动已结束"
    */
    
    let activityType=0
    let days,hours,minutes,seconds;

    
    if(startDistance<0 && endDistance>0){// 活动进行中
        activityType=1
        days=-Math.floor(endDistance / (day));
        hours=-Math.floor((endDistance % (day)) / (hour));
        minutes=-Math.floor((endDistance % (hour)) / (minute));
        seconds=-Math.floor((endDistance % (minute)) / second);
    }else if(endDistance<=0 && startDistance<0){// 活动结束
        activityType=2
    }else{// 活动未开始
        activityType=0 
        days=-Math.floor(startDistance / (day));
        hours=-Math.floor((startDistance % (day)) / (hour));
        minutes=-Math.floor((startDistance % (hour)) / (minute));
        seconds=-Math.floor((startDistance % (minute)) / second);
    }

    return {
        activityType,
        startDistance,
        endDistance,
        DD:-days,
        HH:-hours,
        MM:-minutes,
        SS:-seconds
    }
}